var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_6136)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.94244L11.7713 12.7138C11.8971 12.8352 12.0655 12.9024 12.2403 12.9009C12.4151 12.8994 12.5823 12.8293 12.7059 12.7057C12.8295 12.582 12.8996 12.4148 12.9011 12.24C12.9026 12.0652 12.8354 11.8968 12.714 11.7711L8.94267 7.99977L12.714 4.22844C12.8354 4.10271 12.9026 3.9343 12.9011 3.75951C12.8996 3.58471 12.8295 3.4175 12.7059 3.2939C12.5823 3.17029 12.4151 3.10018 12.2403 3.09866C12.0655 3.09714 11.8971 3.16434 11.7713 3.28577L8 7.05711L4.22867 3.28577C4.10237 3.16734 3.93495 3.10268 3.76182 3.1055C3.5887 3.10831 3.42347 3.17836 3.30108 3.30084C3.17869 3.42331 3.10875 3.5886 3.10606 3.76172C3.10337 3.93485 3.16815 4.10222 3.28667 4.22844L7.05734 7.99977L3.286 11.7711C3.22233 11.8326 3.17154 11.9062 3.1366 11.9875C3.10166 12.0688 3.08327 12.1563 3.0825 12.2448C3.08174 12.3334 3.0986 12.4211 3.13212 12.5031C3.16564 12.585 3.21515 12.6594 3.27774 12.722C3.34034 12.7846 3.41477 12.8341 3.4967 12.8677C3.57863 12.9012 3.66642 12.918 3.75494 12.9173C3.84346 12.9165 3.93094 12.8981 4.01227 12.8632C4.09361 12.8282 4.16717 12.7774 4.22867 12.7138L8 8.94244Z",
    fill: "#777E91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_6136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 -0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7ed00dcc11694bca6f46564f70371a93.svg";
export { ForwardRef as ReactComponent };